import { navigate, Link } from "gatsby"
import _ from "lodash"
import React, { useContext, useEffect } from "react"
import tw from "twin.macro"
import useTealiumView from "../../../hooks/Tealium/useTealiumView"
import { ButtonLink } from "../../atoms/Button"
import Icon from "../../atoms/Icon"
import { SearchBar } from "../SearchBar"
import { LanguageContext } from "../../../contexts/Language"
import useTealiumEvent from "../../../hooks/Tealium/useTealiumEvent"

const NotFoundOffer = () => {
  const { _ } = useContext(LanguageContext)
  //
  // Tealium
  const { handleTealView } = useTealiumView()
  const { trackTealEvent } = useTealiumEvent()

  useEffect(() => {
    handleTealView({
      page_name: "expired offer",
      page_type: "error",
      tealium_event: "expired_offer",
      error_message: `oops... That Toyota Deal has expired`,
    })
  }, [])
  return (
    <div>
      <section
        css={[
          tw`min-h-[calc(100vh - 50px)] lg:min-h-[calc(100vh - 50px)] w-full bg-cover bg-no-repeat px-4 pt-8 bg-center lg:bg-bottom`,
          `background-image: url(../../not_found_offer_bg_desktop.jpg)`,
          `@media (max-width: 660px) {
            background-image: url(../../not_found_offer_bg_mobile.jpg);
          }`,
        ]}
      >
        <div css={tw`max-w-[1440px] mx-auto`}>
          <button
            css={[tw`flex items-center text-xs text-red-400 md:ml-10 lg:ml-24`]}
            onClick={() => navigate(-1)}
          >
            <Icon.Chevron
              color="red-400"
              direction="left"
              css={[tw`mr-1 w-2`]}
            />
            {_("BACK")}
          </button>
        </div>
        <div css={tw`max-w-xl mx-auto text-center pt-20`}>
          <div css={[tw`bg-opacity-80 bg-white rounded-xl p-6`]}>
            <h1 css={tw`text-red-400 font-semibold mb-2 uppercase`}>
              oops... That Toyota Deal has expired
            </h1>
            <h2
              css={[tw`text-2xl font-light mb-6 font-book`, tw`lg:(text-5xl)`]}
            >
              Check out all our current Toyota Offers
            </h2>
            <p>
              We're sorry the Toyota Offer you are looking for is gone but check
              out all our current Toyota Deals, there's sure to be one for you!
            </p>
          </div>
          <div css={tw`grid grid-cols-2 items-center gap-2 md:gap-6`}>
            <ButtonLink
              to="/offers"
              primary
              css={tw`w-auto`}
              onClick={() =>
                trackTealEvent({
                  tealium_event: "cta_click",
                  link_href: "/offers",
                  coupon_module_text: "All Toyota Offers",
                })
              }
              analytics-id={`All Toyota Offers:hero`}
            >
              All Toyota Offers
            </ButtonLink>
            <SearchBar mobileView={false} secondarySearchBar={true} />
          </div>
        </div>
      </section>
    </div>
  )
}

export default NotFoundOffer
